import { ACCOUNT_ADMIN_DRAWER_SLIDE_MS } from '../constants/accountAdminNav.constants'

/** Style keys applied on web when the org admin drawer nudges main content. */
export interface WebAccountAdminDrawerPushStyle {
  marginLeft: number
  width: string
  maxWidth: string
  transition: string
}

const drawerPushTransition = `margin-left ${ACCOUNT_ADMIN_DRAWER_SLIDE_MS}ms ease-out, width ${ACCOUNT_ADMIN_DRAWER_SLIDE_MS}ms ease-out, max-width ${ACCOUNT_ADMIN_DRAWER_SLIDE_MS}ms ease-out`

/**
 * Margin + matching width so centered content aligns with the visible viewport when the drawer is open.
 */
export function buildWebAccountAdminDrawerPushStyle(
  shiftPx: number,
): Partial<WebAccountAdminDrawerPushStyle> {
  if (shiftPx <= 0) {
    return {}
  }
  const inset = `calc(100% - ${shiftPx}px)`
  return {
    marginLeft: shiftPx,
    width: inset,
    maxWidth: inset,
    transition: drawerPushTransition,
  }
}
